<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconAddSomeone_24"
>
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.5 2.75a.75.75 0 0 1 .75.75v1.75H22a.75.75 0 0 1 0 1.5h-1.75V8.5a.75.75 0 0 1-1.5 0V6.75H17a.75.75 0 0 1 0-1.5h1.75V3.5a.75.75 0 0 1 .75-.75ZM11 12.587a3.68 3.68 0 0 0 3.677-3.678A3.68 3.68 0 0 0 11 5.233a3.681 3.681 0 0 0-3.678 3.676A3.682 3.682 0 0 0 11 12.587Zm6.021 3.359c-.959-1.026-2.767-1.788-6.021-1.788-3.282 0-5.093.775-6.046 1.814l-.026.029c-.258.28-.674.734-.848 1.848A1.005 1.005 0 0 0 5.072 19h11.856c.61 0 1.086-.548.992-1.151-.178-1.136-.607-1.593-.885-1.888l-.014-.015Z"
        fill="currentColor"
    />
</svg>
